import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAILER = {
  nickname: 'PRODUCTS.TRAILER.nickname',
  properties: [
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      pattern: /[a-zA-Z]{2}\d{5}/,
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'trailerMark', key: 'WTC_MARK', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    {
      name: 'trailerModel', key: 'WTC_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE_WTC', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
        ]
      }
    },
    { name: 'trailerType', key: 'TRAILER_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.ANOTHER_TRAILER', value: 'ANOTHER_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.CAR_TRANSPORT_TRAILER', value: 'CAR_TRANSPORT_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.BOAT_TRAILER', value: 'BOAT_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.MACHINE_TRAILER', value: 'MACHINE_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.ITEM_TRAILER', value: 'ITEM_TRAILER' },
        ]
      }
    },
    { name: 'trailerMarketValue', key: 'WTC_TRAILER_MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'deductible', key: 'WTC_VOLUNTARY_EXCESS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VOLUNTARY_EXCESS.50', value: 50000 },
        ]
      }
    },
    { name: 'tifGroup', key: 'TFA_ANNUAL_FEE_GROUP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isHugeSelectContainer: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_000', value: 'GROUP_000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_100', value: 'GROUP_100' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_110', value: 'GROUP_110' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_200', value: 'GROUP_200' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_300', value: 'GROUP_300' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_400', value: 'GROUP_400' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TFI_GROUP.GROUP_900', value: 'GROUP_900' }
        ]
      }
    },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR_MODEL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'zipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]],
      customProductTypeConfig: {
        TRAILER: {
          key: 'OBJECT_ZIP_INVALID'
        }
      }
    },
  ],
  icon:'trailer'
};
